import React from 'react';
import OnboardingIndex from './OnboardingIndex';

const OnboardingTwistGo = () => {
  return <OnboardingIndex isTwistGo />;
};

export default OnboardingTwistGo;
